import script from "./alarmQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmQuery.vue?vue&type=script&setup=true&lang=js"

import "./alarmQuery.vue?vue&type=style&index=0&id=38ce183e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ce183e"]])

export default __exports__